function resetInputField(input) {
  input.type = ''; // Temporarily change the type to clear
  input.type = 'file'; // Reset back to file input
}

document
  .getElementById('featured_image')
  .addEventListener('change', function (event) {
    if (this.files && this.files[0]) {
      let imageFile = this.files[0];

      // Define the maximum file size (e.g., 1MB)
      const maxFileSize = 1 * 1024 * 1024; // 1MB in bytes

      // Check if the file exceeds the maximum size
      if (imageFile.size > maxFileSize) {
        alert('The file is too large. Please upload a file smaller than 1MB.');
        resetInputField(this); // Reset the input to allow the user to choose another file
        return; // Exit the function early
      }

      let reader = new FileReader();
      reader.onload = function (e) {
        let imagePreview = document.createElement('img');
        imagePreview.src = e.target.result;
        imagePreview.classList.add('image-preview');

        // hide label
        const label = document.querySelector('.custom-file-label');
        label.style.display = 'none';

        const cancelButton = document.createElement('button');
        cancelButton.classList.add('cancel-button');
        cancelButton.addEventListener('click', function () {
          // Hide the image preview and cancel button
          document.querySelector('.image-preview').remove();
          document.querySelector('.cancel-button').remove();
          // Reset the input
          resetInputField(document.getElementById('featured_image'));
          // Show the file input again
          document.querySelector('.custom-file-input').style.display = 'block';
          // show the label again
          label.style.display = 'block';
        });

        const container = document.getElementById('imageUploadContainer');
        container.appendChild(imagePreview);
        container.appendChild(cancelButton);
        // Hide the original file input to only show the image and cancel button
        document.querySelector('.custom-file-input').style.display = 'none';
        document.querySelector('.image-preview').style.display = 'block';
        document.querySelector('.cancel-button').style.display = 'block';
      };

      reader.readAsDataURL(imageFile);
    }
  });

// function for checkboxes
document
  .querySelectorAll('.pill-button input[type="checkbox"]')
  .forEach((checkbox) => {
    // Listen for the 'change' event on each checkbox
    checkbox.addEventListener('change', function () {
      // Toggle the 'selected' class on the parent label based on the checkbox's checked state
      if (this.checked) {
        this.parentElement.classList.add('selected');
      } else {
        this.parentElement.classList.remove('selected');
      }
    });
  });

// function for star ratings
document.addEventListener('DOMContentLoaded', () => {
  const ratingStars = document.querySelectorAll(
    '.rating-stars input[type="radio"]'
  );
  const ratingLabels = document.querySelectorAll('.rating-stars label');

  function updateStars(target, hover = false) {
    let fill = false;
    Array.from(ratingLabels)
      .reverse()
      .forEach((label) => {
        if (label.htmlFor === target.id) fill = true;
        if (fill) {
          label.classList.add('selected');
        } else if (!hover) {
          label.classList.remove('selected');
        }
      });
  }

  function clearHoverEffect() {
    // First, remove 'selected' from all labels
    ratingLabels.forEach((label) => label.classList.remove('selected'));

    // Then, find the checked star and reapply the 'selected' class as needed
    const checkedStar = document.querySelector(
      '.rating-stars input[type="radio"]:checked'
    );
    if (checkedStar) {
      updateStars(checkedStar);
    }
  }

  ratingStars.forEach((star) => {
    star.addEventListener('mouseover', () => updateStars(star, true));
    star.addEventListener('mouseout', clearHoverEffect);
    star.addEventListener('change', () => updateStars(star));
  });
});
